




































































































































import {Vue, Component} from 'vue-property-decorator';
import InspectionFirstStep from '@/views/Inspection/InspectionFirstStep.vue';
import InspectionSecondStep from '@/views/Inspection/InspectionSecondStep.vue';
import InspectionThirdStep from '@/views/Inspection/InspectionThirdStep.vue';
import InspectionFourthStep from '@/views/Inspection/InspectionFourthStep.vue';
import {mapActions, mapGetters} from 'vuex';
import {extractDetailsFromBase64} from '@/services/api/image';
import moment from 'moment';
import {API} from '@/services/api/api';
import router from '@/router';
import {getImage} from '@/utils/Utils';

@Component({
  components: {
    InspectionFirstStep,
    InspectionSecondStep,
    InspectionThirdStep,
    InspectionFourthStep,
  },
  methods: {
    ...mapActions(['setInspectionData', 'showSuccessToast', 'showErrorToast']),
  },
  computed: {
    ...mapGetters(['getInspectionData']),
  },
})
export default class EditInspection extends Vue {
  stepNumber: number = 1;
  inspectionId = this.$route.params.id;
  isScreenLoading = true;
  getInspectionData: any;
  showSuccessToast: any;
  showErrorToast: any;
  btnLoader = false;
  setInspectionData: any;
  parentInspectionId: string | null = null;
  inspectionNumber: number | null = null;

  inspectionData: any;

  imageData = [];

  stepsHeader = [
    {
      stepCount: 1,
      displayName: 'Select Inspection Point',
    },
    {stepCount: 2, displayName: 'Inspection Details'},
    {stepCount: 3, displayName: 'Select Recipient'},
    {stepCount: 4, displayName: 'Summary'},
  ];

  mounted() {
    this.getInspectionDataById();
  }

  async getInspectionDataById() {
    try {
      const response = await API.fetchInspectionDataById(this.inspectionId);

      if (response.data) {
        const data = response.data;
        this.inspectionData = data;
        this.parentInspectionId = data.parentInspectionId;
        this.inspectionNumber = data.inspectionNumber;
        await this.mappDataToFields();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network Error'});
    }
  }

  async mappDataToFields() {
    //

    const inspectionPoint = this.inspectionData.inspectionPoint;
    const inspectionDetail = this.inspectionData.inspectionDetail;
    const attachment = this.inspectionData.inspectionAttachment;
    const mailData = this.inspectionData.inspectionRecipient;
    const deck = this.inspectionData.deck;

    const modifyAttachment = attachment.map((me) => {
      return {...me, filePath: me.filePath + me.fileName};
    });

    //
    const img = await getImage(deck.imagePath);
    this.setInspectionData({
      key: 'firstStep',
      payload: {
        frameSide: inspectionPoint.frameSide,
        shipId: inspectionPoint.shipId,
        isMisc: inspectionPoint.isMisc,
        deckId: inspectionPoint.deckId,
        structure: inspectionPoint.structure,
        zoneId: inspectionPoint.zoneMasterId,
        zoneName: inspectionPoint.zoneName,
        inspectionCode: inspectionDetail.inspectionID,
        deckImage: img,
        location_X: inspectionPoint.location_X,
        location_Y: inspectionPoint.location_Y,
        frameNumber: inspectionDetail.frameNumber,

        frameStart: inspectionPoint.frameStart,
        frameEnd: inspectionPoint.frameEnd,
      },
    }),
      //
      //   'mapped fieds in edit is',
      //   this.getInspectionData.firstStep.frameNumber
      // );
      //
      //   'in setInspectionData in edit inspection',
      //   inspectionPoint.frameStart,
      //   inspectionPoint.frameEnd
      // );

      this.setInspectionData({
        key: 'secondStep',
        payload: {
          inspectionDate: moment(inspectionDetail.inspectionDate).format('YYYY-MM-DD'),
          voyageConditionId: inspectionDetail.voyageConditionId,
          voyage: inspectionDetail.voyageData,
          findingId: inspectionDetail.findingsId,
          frame: inspectionDetail.frameNumber,
          length: inspectionDetail.dimentionLength,
          lengthUnit: inspectionDetail.lengthUnit,
          width: inspectionDetail.dimentionWidth,
          widthUnit: inspectionDetail.widthUnit,
          workOrder: inspectionDetail.workOrder,
          severityId: inspectionDetail.severityId,
          summary: inspectionDetail.summary,
          reInspectionDate: moment(inspectionDetail.reInspectionDate).format('YYYY-MM-DD'),
          isActionPlanReq: inspectionDetail.isActionPlanRequired,
          isActive: inspectionDetail.isActive,

          attachment: modifyAttachment,
        },
      }),
      this.setInspectionData({
        key: 'thirdStep',
        payload: mailData,
      });

    this.isScreenLoading = false;
  }

  closeLoader() {
    this.isScreenLoading = false;
  }

  increaseStep() {
    var validator;
    switch (this.stepNumber) {
      case 1:
        validator = this.$refs.firstStep;
        return validator.firstStepValidator();
      case 2:
        validator = this.$refs.secondStep;
        return validator.saveSecondStepData();
      case 3:
        validator = this.$refs.thirdStep;
        return validator.saveThirdStepData();
      default:
        break;
    }
  }

  decreaseStep() {
    this.stepNumber--;
  }

  goToStep(step) {
    //
    // var validator;
    // switch (this.stepNumber) {
    //   case 1:
    //     validator = this.$refs.firstStep;
    //     return validator.firstStepValidator();
    //   case 2:
    //     validator = this.$refs.secondStep;
    //     return validator.saveSecondStepData();
    //   case 3:
    //     validator = this.$refs.thirdStep;
    //     return validator.saveThirdStepData();
    //   default:
    //     break;
    // }
  }

  switchScreen() {
    this.stepNumber++;
  }

  async onUpateClick() {
    this.btnLoader = true;

    const firstStep = this.getInspectionData.firstStep;
    const secondStep = this.getInspectionData.secondStep;
    const attachment = this.getInspectionData.secondStep.attachment;

    var imageData = $.extend(true, [], attachment);
    //

    imageData.forEach((data) => {
      if (!data.filePath.includes('base64')) {
        data.filePath = data.filePath.slice(0, data.filePath.lastIndexOf('/') + 1);
      } else data.filePath = data.filePath = extractDetailsFromBase64(data.filePath).url;
    });
    //

    const thirdStep = this.getInspectionData.thirdStep;

    const params = {
      inspectionId: this.inspectionId,
      parentInspectionId: this.parentInspectionId,
      inspectionNumber: this.inspectionNumber,
      inspectionPoint: {
        shipId: firstStep.shipId,
        deckId: firstStep.deckId,
        isMisc: firstStep.isMisc,
        zoneMasterId: firstStep.zoneId,
        structure: firstStep.structure,
        location_X: firstStep.location_X,
        location_Y: firstStep.location_Y,

        frameSide: firstStep.frameSide,
        frameStart: firstStep.frameStart,
        frameEnd: firstStep.frameEnd,
      },
      inspectionDetail: {
        inspectionDate: moment(secondStep.inspectionDate).format('YYYY-MM-DDThh:mm:ss'),
        inspectionID: firstStep.inspectionCode,
        voyageData: secondStep.voyage,

        voyageConditionId: secondStep.voyageConditionId,
        findingsId: secondStep.findingId,
        frameNumber: secondStep.frame,
        dimentionLength: secondStep.length,
        lengthUnit: secondStep.lengthUnit,
        dimentionWidth: secondStep.width,
        widthUnit: secondStep.widthUnit,
        zoneMasterId: firstStep.zoneMasterId,
        workOrder: secondStep.workOrder,
        severityId: secondStep.severityId,
        summary: secondStep.comment,
        reInspectionDate: moment(secondStep.reInspectionDate).format('YYYY-MM-DDThh:mm:ss'),
        isActionPlanRequired: secondStep.isActionPlanReq,
        isActive: secondStep.isActive,
      },
      inspectionRecipient: {
        mailToUserId: thirdStep.mailToUserId,
        mailCcUserId: thirdStep.mailCcUserId,
        mailCcEmailAddress: thirdStep.mailCcEmailAddress,
      },
      inspectionAttachment: imageData,
    };
    //
    try {
      const response = await API.updateInspection(this.inspectionId, params);
      //

      if (response.data) {
        // this.$router.push('/ship-inspection-list');
        this.$router.go(-1);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  onBackBtnClick() {
    this.$router.go(-1);
  }
}
